// Initial state 
const state = {
    ContractorStatementSummary: null,
    StatementStatus: null,
    IsCardsLoading: null,
    SelectedStatementIds: null,
    SelectedNphiesStatusIds: null,
    BundleIdInputValue: null,
    IsFilterByBundleId: null,
    IsSearchAndFilterBtnsDisabled: null,
    SelectedStatementStatusIDs: null,
    isBundleIDFilterApplied: false,
    selectedStatements: [],
    ContractorClientsDS: [],
    SelectedContractorClientIds: null
};

// Update Data "mutations"
const mutations = {
    setContractorStatementSummary(state, value) {
        debugger;
        state.ContractorStatementSummary = value;
    },
    setStatementStatus(state, value) {
        state.StatementStatus = value;
    },
    setSelectedStatementIds(state, value) {
        state.SelectedStatementIds = value
    },
    setSelectedStatementStatusIDs(state, value) {
        state.SelectedStatementStatusIDs = value;
    },
    setSelectedNphiesStatusIds(state, value) {
        state.SelectedNphiesStatusIds = value
    },
    setBundleIdInputValue(state, value) {
        state.BundleIdInputValue = value
    },
    setIsFilterByBundleId(state, value) {
        state.IsFilterByBundleId = value
    },
    setIsSearchAndFilterBtnsDisabled(state, value) {
        state.IsSearchAndFilterBtnsDisabled = value
    },
    setIsBundleIDFilterApplied(state, value) {
        state.isBundleIDFilterApplied = value;
    },
    setSelectedStatements(state, value) {
        state.selectedStatements = value;
    },
    setContractorClientsDS(state, value) {
        state.ContractorClientsDS = value;
    },
    setSelectedContractorClientIds(state, value) {
        state.SelectedContractorClientIds = value
    }
};
// Get data
const getters = {
    getContractorStatementSummary: state => {
        return state.ContractorStatementSummary;
    },
    getStatementStatus: state => {
        return state.StatementStatus;
    },
    getSelectedStatementIds: state => {
        return state.SelectedStatementIds;
    },
    getSelectedStatementStatusIDs: state => {
        return state.SelectedStatementStatusIDs;
    },
    getSelectedNphiesStatusIds: state => {
        return state.SelectedNphiesStatusIds;
    },
    getBundleIdInputValue: state => {
        return state.BundleIdInputValue;
    },
    getIsFilterByBundleId: state => {
        return state.IsFilterByBundleId;
    },
    getIsSearchAndFilterBtnsDisabled: state => {
        return state.IsSearchAndFilterBtnsDisabled;
    },
    getIsBundleIDFilterApplied: state => {
        return state.isBundleIDFilterApplied;
    },
    getSelectedStatements: state => {
        return state.selectedStatements;
    },
    getContractorClientsDS: state => {
        return state.ContractorClientsDS;
    },
    getSelectedContractorClientIds: state => {
        return state.SelectedContractorClientIds
    },
};

export default {
    mutations,
    state,
    getters
};